<div
  class="tab-pane fade flex-even active show"
  id="insurance-claim-documents"
  role="tabpanel"
  aria-labelledby="insurance-claim-documents-tab"
>
@let isReadOnly = (isReadOnly$ | async) ?? false;
  <div class="d-flex flex-column h-100">
    <div class="row mt-2">
      <div class="col-12 col-md">
        <div class="form-group-title my-1" translate>
          INSURANCE_CLAIM_FIELDSET_DOCUMENTS
        </div>
        <div class="row mt-2">
          <div class="col-12">
            @if (sortedDocuments$ | async; as sortedDocuments) {
              @for (document of sortedDocuments; track document.id) {
                <app-tab-document-request-card
                  [documentModel]="document"
                  (onNewDocumentRefresh)="onNewDocument($event)"
                  (onDocumentDownload)="onDocumentDownload($event)"
                  (onDocumentEdit)="onDocumentEdit($event)"
                  (onDocumentDelete)="onDocumentDelete($event)"
                  [isEditMode]="true"
                />
              }
            }
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 col-md">
        <div class="form-group-title my-1" translate>
          INSURANCE_CLAIM_FIELDSET_DOCUMENTS_AVAILABLE
        </div>
        @if (this.allDocuments$ | async; as availableDocuments) {
          <app-generic-grid
            [data]="availableDocuments"
            [tabViewName]="'allDocuments'"
            [dragAndDrop]="!isReadOnly"
            [rowHeight]="25"
            [pageSize]="10"
            (onActionClickedSetRowData)="onSetRowData($event)"
          />
          <!--              dragAndDrop ou ajouter input -->
        }

        <div class="row mt-2">
          <div class="col-6">
            <app-document-upload-drag-and-drop
              [entityId]="this.contactId().toString()"
              [entityType]="'Contact'"
              [multiple]="true"
              [button_label]="'CONTACT_LBL_DOCUMENTS_ADD'"
              [isDefaultUse]="false"
              [showDescription]="false"
              (onAddedDocumentRefresh)="onRefreshContactDocument($event)"
              [isEditMode]="true"
            />
          </div>
          <div class="col-6">
            <app-document-upload-drag-and-drop
              [entityId]="this.insuranceClaimId().toString()"
              [entityType]="'InsuranceClaim'"
              [multiple]="true"
              [button_label]="'INSURANCE_CLAIM_LBL_DOCUMENTS_ADD'"
              [isDefaultUse]="false"
              [showDescription]="false"
              (onAddedDocumentRefresh)="onRefreshInsuranceClaimDocument($event)"
              [isEditMode]="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
